<div class="text-center px-4">
  <div class="d-flex justify-content-center text-start mt-4">
    <p>{{ offer.TermsAndConditions }}</p>
  </div>
  <div class="d-flex justify-content-center">
    <button class="btn btn-danger mb-4" (click)="closeModal()">Close</button>
  </div>
</div>
